import React, { Component } from "react";
import PropTypes from "prop-types";
import { getFullUrl } from "lib/utils/urls";

export default class MenuBarLink extends Component {
  render() {
    const { link } = this.props;

    const currentPage = typeof window === "object" ? window.location.href : null;
    const isActiveClass =
      currentPage == link.url ? "secondary-color-text" : "primary-color-text";

    const fullUrl = getFullUrl(link.url, link.external);

    return (
      <div className="giving-nav-link primary-color-text">
        <a
          data-testid="t-MenuBar-GivingD--MenuBar-a"
          href={fullUrl.href}
          target={link.external ? "_blank" : null}
          className={isActiveClass}
          rel={link.external ? "noreferrer" : null}>
          {link.text}
        </a>
      </div>
    );
  }
}
